import { render, staticRenderFns } from "./AddressFooter.vue?vue&type=template&id=75268bd2&lang=html&"
import script from "./AddressFooter.vue?vue&type=script&lang=ts&"
export * from "./AddressFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AddressFooter.vue?vue&type=style&index=0&id=75268bd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports